/**
 * Quais conexões de sala abrir e quais fechar.
 *
 * ## O que estava errado
 *
 * O `LeftSideBar` percorria as salas em andamento e chamava
 * `addSocketConnection` para cada uma. Aquela função criava um socket.io por
 * sala e terminava com `return () => roomSocket.disconnect()` — só que ela é
 * uma função comum, não um `useEffect`: **a limpeza era descartada e nunca
 * rodava**. Uma conexão por sala, que não fechava quando a sala saía da lista.
 *
 * E `addSocketConnection` era redefinida a cada render do provider, estando na
 * lista de dependências do efeito — então o efeito disparava a cada render, e a
 * guarda lia um `socketConnections` desatualizado do fechamento, abrindo
 * conexão duplicada da mesma sala nessa janela.
 *
 * ## O que esta função resolve
 *
 * Transforma "sincronizar conexões" numa decisão pura: o que falta abrir e o
 * que sobra fechar. **Idempotente** — é essa propriedade que faz o efeito poder
 * disparar à vontade sem criar nada.
 *
 * Uma conexão POR SALA continua sendo o desenho: é o que o servidor de ws
 * espera, com `roomId` na query. Consolidar em uma única conexão exigiria
 * mexer no servidor, e isso está fora do pedido.
 */

const normalizar = (ids) =>
    (Array.isArray(ids) ? ids : [])
        .filter((id) => id !== null && id !== undefined && String(id) !== '')
        .map((id) => String(id));

/**
 * @param {Array<string|number>} desejados ids das salas que devem ter conexão
 * @param {Array<string|number>} abertos ids das salas que já têm conexão
 * @returns {{abrir: string[], fechar: string[]}}
 */
export const diferencaDeConexoes = (desejados, abertos) => {
    const querido = [...new Set(normalizar(desejados))];
    const vivo = [...new Set(normalizar(abertos))];

    const vivoSet = new Set(vivo);
    const queridoSet = new Set(querido);

    return {
        abrir: querido.filter((id) => !vivoSet.has(id)),
        fechar: vivo.filter((id) => !queridoSet.has(id)),
    };
};
